export const LOGIN_USER_INFO = 'LOGIN_USER_INFO';
export const DISPLAY_ADMIN_PROFILE = 'DISPLAY_ADMIN_PROFILE';
export const SHOW_COOKIE_POLICY = 'SHOW_COOKIE_POLICY';
export const REMEMBER_ME='REMEMBER_ME';


